import React from "react";
import { EventLog_EventFragment } from "@graphql";
import { Event } from "../Event/Event";
import { StyledHtml } from "@common/StyledHtml";

type Props = {
  item: EventLog_EventFragment;
};

export function SearchEvent(props: Props) {
  return (
    <Event item={props.item}>
      <StyledHtml>{props.item.DescriptionHtml}</StyledHtml>
    </Event>
  );
}
